import { createAction, props } from '@ngrx/store';
import { WhatsappTemplate } from './whatsapp-template.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records whatsapp template'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records whatsapp template success', 
    props<{ listData: WhatsappTemplate[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records whatsapp template failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record whatsapp template',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record whatsapp template success', 
    props<{ singleData: WhatsappTemplate }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record whatsapp template failure', 
    props<{ error: string }>()
);


// Add Data
export const addRecord = createAction(
    '[Data] Add record whatsapp template',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record whatsapp template success'
);
export const addRecordFailure = createAction(
    '[Data] Add record whatsapp template failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record whatsapp template',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record whatsapp template success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record whatsapp template failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record whatsapp template',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record whatsapp template success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record whatsapp template failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state whatsapp template',
);